import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionCTA } from './SectionCTA';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-16" aria-labelledby="faq-title" data-id="element-111" data-mp="1ceqefpoyz1ic">
      <div className="mx-auto max-w-3xl" data-id="element-112" data-mp="1ccncq8egfjxs">
        <h2 id="faq-title" className="text-center font-serif text-[2rem] font-bold leading-tight text-ink sm:text-5xl" data-id="element-113" data-mp="2a2idyqbi2et3">
          Frequently asked questions
        </h2>

        <div className="mt-10 space-y-3" data-id="element-114" data-mp="2042n8ogdx7k4">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white" data-id="element-115" data-mp="1v3y5kv3qq6sb" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" data-id="element-116" data-mp="op5tx2d63w6y">
                  <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-117" data-mp="1pkqmfmaci8qd">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-gold' : 'bg-ink'}`} data-id="element-118" data-mp="1arn6fjcek31r">
                    <PlusIcon className={`h-4 w-4 ${isOpen ? 'text-ink' : 'text-gold'}`} aria-hidden="true" data-id="element-119" data-mp="16pa0ouxno54z" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-120" data-mp="wxcp3n2qjb5q">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-121" data-mp="iymt6arnjhiy">
                      <p className="px-5 pb-5 text-base leading-relaxed text-muted" data-id="element-122" data-mp="2kvewz4yw6ip3">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCTA label="I’m ready — give me access" data-id="element-123" data-mp="2azbutz41ik25" />
      </div>
    </section>;
}